import React from "react";
import PrerenderedHero from "../components/home/PrerenderedHero";
import StatRail from "../components/home/StatRail";
import HomeServicesGrid from "../components/home/HomeServicesGrid";
import FeaturedProjects from "../components/home/FeaturedProjects";
import ProcessSection from "../components/home/ProcessSection";
import ValuesSection from "../components/home/ValuesSection";
import TestimonialsSection from "../components/home/TestimonialsSection";
import ServiceAreasPreview from "../components/home/ServiceAreasPreview";
import HomeFinalCTA from "../components/home/HomeFinalCTA";

// Home renders the SAME static hero markup that the HTML shell pre-renders.
// We deliberately drop the framer-motion Hero (Hero.jsx) on the homepage so
// that when React mounts there's no second <img> fetch + paint, no layout
// jiggle from entrance animations, and the LCP element is identifiable
// (it's the same <img> the browser already painted from the shell).
export default function Home() {
  return (
    <>
      <PrerenderedHero />
      <StatRail />
      <HomeServicesGrid />
      <FeaturedProjects />
      <ProcessSection />
      <ValuesSection />
      <TestimonialsSection />
      <ServiceAreasPreview />
      <HomeFinalCTA />
    </>
  );
}